export default {
  root: {
    '&:hover:not($disabled)': {
      backgroundColor: '#f8fafc'
    }
  }
};
